// extracted by mini-css-extract-plugin
module.exports = {"dragPreview":"QualityProfileItemDragPreview-dragPreview-hoRc8"};